export const FETCH_DATA_REQUEST_CATEGORY = "FETCH_DATA_REQUEST_CATEGORY";
export const FETCH_DATA_SUCCESS_CATEGORY = "FETCH_DATA_SUCCESS_CATEGORY";
export const FETCH_DATA_FAILURE_CATEGORY = "FETCH_DATA_FAILURE_CATEGORY";